export default {"src":"/_next/static/media/flowbite_language-outline.d4abc8b6.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};